import "./HelpButton.less";

import { GuxIcon, GuxTooltip } from "genesys-spark-components-react";

export function HelpButton({ helpText = undefined }: { helpText?: string }) {
    return helpText ? (
        <div className="help-text">
            <GuxIcon
                icon-name="fa/circle-question-regular"
                screenreader-text={helpText}
            ></GuxIcon>
            <GuxTooltip placement="bottom-end">
                <span slot="content">{helpText}</span>
            </GuxTooltip>
        </div>
    ) : null;
}
